export default __webpack_public_path__ + "static/media/RIZ04064.47733863.JPG";